import { render, staticRenderFns } from "./set_avatar.vue?vue&type=template&id=70abeb00&scoped=true"
import script from "./set_avatar.vue?vue&type=script&lang=js"
export * from "./set_avatar.vue?vue&type=script&lang=js"
import style0 from "./set_avatar.vue?vue&type=style&index=0&id=70abeb00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70abeb00",
  null
  
)

export default component.exports